export const BaseTelephoneInput = {
  name: 'BaseTelephoneInput',
  data () {
    return {
      selectedCountryCode: 'UA',
      masksList: {
        'UA': '(###)###-####',
        'US': '(###)###-####',
        'CA': '(###)###-####',
        'GB': '(###)#-######',
        'ES': '(###)###-###',
        'IT': '(###)####-###',
        'PL': '(###)###-###',
        'FI': '(###)-###-###'
      },
      phoneDropdownOptions: {
        showDialCodeInList: true,
        showDialCodeInSelection: true,
        showFlags: true,
        showSearchBox: true,
        tabindex: 0,
        width: '390px',
      },
      phoneInputOptions: {
        autocomplete: 'on',
        autofocus: false,
        'aria-describedby': '',
        id: '',
        maxlength: 25,
        name: 'phone-number',
        showDialCode: false,
        placeholder: this.$t('Phone Number *'),
        readonly: false,
        required: true,
        tabindex: 0,
        type: 'text',
        styleClasses: 'col-xs-12'
      },
      isNotValidPhone: false
    }
  },
  computed: {
    phoneMask () {
      return this.masksList[this.selectedCountryCode]
    },
    phoneMaskObj () {
      return {
        mask: this.phoneMask,
        showMaskOnHover: false,
        autoUnmask: true
      }
    }
  },
  methods: {
    countryChanged (country) {
      this.selectedCountryCode = country.iso2
    },
    checkValidation (valid) {
      this.isNotValidPhone = valid.$invalid
    }
  },

}
